<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs  {{
		sectionclass
	}}"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div *ngIf="hasData" class="reachFrequencyDiv">
		<ngu-carousel
			#carousel
			[inputs]="carouselOne"
			(carouselLoad)="initDataFn($event)"
			[dataSource]="campaignsList"
			class="leftCarousel"
		>
			<ngu-tile NguCarouselItem class="col-xl-12 metricsHeader" *nguCarouselDef="let campaign; let i = index">
				<div class="stats-container">
					<div class="campaigns-toggle">
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									(click)="prevArrow(i); scrollGraph(i - 1)"
									src="../../../../../assets/images/chevron-left-large.png"
								/>
							</a>
						</div>
						<div class="campaign-name">
							<h5>
								<div class="chart-header-text"></div>
								{{ campaign.name }}
							</h5>
						</div>
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									(click)="nextArrow(); scrollGraph(i + 1)"
									src="../../../../../assets/images/chevron-right-large.svg"
								/>
							</a>
						</div>
					</div>
					<div class="lifetime-average">
						<div class="lifetime-average-title">Lifetime Campaign Average</div>
						<div class="reach-frequence-div">
							<div *ngFor="let avg of campaign.averageLifetimes">
								<div class="lifetime-average-metric">
									<div class="metric-value" [ngClass]="{ 'normal-font-weight': avg.isNonZeroValue }">
										{{ avg.parameterValue }}
									</div>
									<div class="metric-title">
										{{ avg.parameterName }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ngu-tile>
		</ngu-carousel>
		<div class="rightCharts">
			<div class="campaignNameHeader">{{ sectiontitle }}</div>
			<div *ngFor="let campaign of campaignsList; let i = index" class="graphSection graphHeader" id="graph_{{ i }}">
				<div class="campaign-name">
					<div class="chart-header-text"></div>
					{{ campaign.name }}
				</div>
				<div class="lifetime-chart">
					<div *ngIf="campaign.showChart; else elseBlockHideChart" class="" style="min-height: 100px">
						<app-chart
							class="individual-chart"
							[setcolor]="customchartconfiguration.setGraphBackgroundColor"
							[chartData]="campaignsList[i]"
						></app-chart>
					</div>
					<ng-template #elseBlockHideChart>
						<div class="individual-chart">
							<p class="no-data-selected-date">No Data Available for the selected dates.</p>
						</div>
					</ng-template>
				</div>
			</div>
		</div>
	</div>
	<div class="no-data-container" *ngIf="!hasData">
		<app-loader [showLoader]="showLoad"></app-loader>
		<div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
	</div>
</div>
